export default __webpack_public_path__ + "static/media/prescription.64c5d375.png";